<template>
  <div>
    <div class="recommend-container" v-if="recommendList && recommendList[0]">
      <div class="title">商品推荐</div>
      <div class="list">
        <div
          class="item"
          v-for="item in recommendList"
          :key="item.id"
          @click="gotoGoodsInfo(item)"
        >
          <img class="image" :src="item.propicpath" />
          <div class="info">
            <div class="name">{{ item.proname }}</div>
            <div class="price">
              <span>{{currencySymbol}}</span>
              <span class="integer">{{ item.prounitprice }}</span>
            </div>
            <button class="now-buy" :style="{ background: colorFirst }" @click="gotoPay">
              立即购买
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Recommend",
  props: {
    recommendList: Array,
    colorFirst: String,
    currencySymbol: String,
    username: String
  },
  data() {
    return {};
  },
  components: {},
  methods: {
    gotoGoodsInfo(item){
      location.href = `/${this.username}/wap_pro/${item.pid}.html`
    },
    gotoPay(){
      // location.href = `/dom/sc_orderbuy.php?username=${this.name}&wap=1&orderType=bargain&bargain_join_id=${this.join_id}`;
    }
  }
};
</script>

<style scoped lang="scss">
/* 推荐商品 */
.recommend-container {
  margin-top: 0.3rem;
  background: #fff;
  margin-bottom: 0.2rem;
  .title {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.3rem;
    color: #999;
    padding-top: 0.3rem;
    margin-bottom: 0.3rem;
    &::after,
    &::before {
      content: "";
      display: block;
      width: 0.6rem;
      height: 0.01px;
      background: #ededed;
    }
    &::after {
      margin-left: 0.18rem;
    }
    &::before {
      margin-right: 0.2rem;
    }
  }
  .list {
    padding: 0 0.25rem;
    display: flex;
    flex-direction: column;
    .item {
      display: flex;
      flex-direction: row;
      padding: 0.3rem 0;
      border-top: 0.01rem solid #ededed;
      &:first-child {
        padding-top: 0;
        border-top: none;
      }
      .image {
        margin-right: 0.42rem;
        flex: 0 0 2.2rem;
        width: 2.2rem;
        height: 2.2rem;
        border-radius: .12rem;
      }
      .info {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;
        .name {
          font-size: 0.3rem;
          overflow : hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        .price {
          font-size: 0;
          color: #e51722;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          span {
            font-size: 0.24rem;
          }
        }
        .integer {
          font-size: 0.38rem !important;
        }
        .now-buy {
          position: absolute;
          right: 0;
          bottom: 0;
          font-size: 0.28rem;
          color: #fff;
          width: 1.6rem;
          height: 0.6rem;
          line-height: 0.6rem;
          background: rgba(255, 46, 31, 1);
          border-radius: 0.05rem;
          padding: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Bargain/components/Recommend.vue